import { Component, OnChanges, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormSettings, SettingsResult } from '../../shared/models/game-settings.model';
import { ApiService } from '../../shared/services/api.service';
import { Router } from '@angular/router';
import { StorageService } from '../../shared/services/storage.service';
import { SocketService } from '../../shared/services/socket.service';
import { GameService } from '../../shared/services/game.service';
import { environment } from '../../../environments/environment';
import { GroupsService } from '../../shared/services/groups-service';
import { Group } from '../../shared/models/group.model';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [ApiService]
})
export class SettingsComponent implements OnInit, OnChanges {

  pdfUrl: string = environment.pdfUrl;

  uuid: string;
  sessionCode: Observable<string>;

  settings: FormSettings;
  settingsResult: SettingsResult;
  settingsForm: FormGroup;

  constructor(private router: Router, private fb: FormBuilder, private apiService: ApiService, private storageService: StorageService, private socketService: SocketService, private gameService: GameService, public groupsService: GroupsService) {

    // this.storageService.getSessionCode().subscribe((sessionCode) => {
    //
    //   if (!isNullOrUndefined(sessionCode))
    //   {
    //     this.sessionCode = sessionCode;
    //     console.log('sessionCode:', this.sessionCode);
    //
    //     this.apiService.getSettings(this.sessionCode)
    //       .subscribe(data => {
    //
    //         this.settingsResult = data;
    //
    //         this.storageService.setUUID(data.uuid).subscribe(data => {
    //           console.log('uuid saved local:', data);
    //         });
    //         this.storageService.setSessionCode(data.sessionCode).subscribe(data => {
    //           console.log('sessionCode saved local:', data);
    //         });
    //
    //         this.rebuildForm();
    //       });
    //   }
    // });
    this.createForm();

    this.getSessionCode()
      .subscribe(sessionCode => {
        this.getSettings(sessionCode)
          .subscribe( settings => {
            this.initBySettings(settings);
          });
      });

    console.log('SettingsComponent', this.groupsService);
  }

  get baseUrl(): string {
    return this.apiService.getPDFBaseUrl();
  }

  get groupArray() {
    return this.settingsForm.get('groupArray') as FormArray;
  }

  get groupNames() {
    return this.settingsForm.get('groupNames') as FormArray;
  }

  getSessionCode(): Observable<string> {
    return this.sessionCode = this.storageService.getSessionCode();
  }

  getSettings(sessionCode): Observable<SettingsResult> {
    return this.apiService.getSettings(sessionCode);
  }

  initBySettings(settings: SettingsResult) {
    // GroupService
    if (!isNullOrUndefined(settings)) {
      this.groupsService.initWithSettings(settings);
    }
  }

  ngOnInit() {
    for (let i = 0; i < this.groupsService.groupItems.length; i++) {
      this.groupArray.push(this.createGroup(this.groupsService.groupItems[i]));
    }
  }

  addGroup() {
    console.log('addGroup');
    const item = this.groupsService.addItem();
    this.groupArray.push(this.createGroup(item));
  }

  removeGroup() {
    console.log('removeGroup');
    const item = this.groupsService.removeItem();
    this.groupArray.removeAt(this.groupArray.length - 1);
  }

  createGroupItems() {
    for (let i = this.groupsService.groupItems.length; i < this.groupsService.defaultAmountGroups; i++) {
      this.groupsService.addItem();
    }
  }

  createForm() {
    this.settingsForm = this.fb.group({
      groupArray: this.fb.array([]),
      duration: ['', [Validators.required, Validators.pattern('[0-9]+')]]
    });

    this.defaultForm();

  }

  createGroup(group: Group): FormGroup {
    return this.fb.group({
      ...group
    });
  }



  ngOnChanges() {
    this.rebuildForm();
  }

  defaultForm() {
    if (isNullOrUndefined(this.settingsResult)) {
      this.settingsForm.reset({
        duration: 50
      });
    }
  }

  rebuildForm() {
    this.settingsForm.reset({
      groups: this.settingsResult.groups,
      duration: this.settingsResult.duration
    });
  }

  onSubmit() {

  }

  prepareSaveSettings(): FormSettings {

    const formModel = this.settingsForm.value;

    const saveSettings: FormSettings = {
      groups: formModel.groupArray.length,
      duration: formModel.duration,
      groupArray: formModel.groupArray
    };

    console.log(saveSettings);

    return saveSettings;
  }

  revert() {
    this.rebuildForm();
  }

  startGame() {

    this.settings = this.prepareSaveSettings();
    this.apiService.updateSettings(this.settings)
      .subscribe(data => {
        console.log('settingsResult', data);
        this.settingsResult = data;
        this.gameService.sessionCode = data.sessionCode;

        this.rebuildForm();

        this.storageService.setUUID(data.uuid).subscribe(data => {
          console.log('uuid saved local:', data);
        });
        this.storageService.setSessionCode(data.sessionCode).subscribe(data => {
          console.log('sessionCode saved local:', data);
          this.router.navigate(['/remote/creating-game']);
        });

      });

  }
}



// WEBPACK FOOTER //
// ./src/app/remote/settings/settings.component.ts